// create sagas
import { call, put, takeLatest } from "redux-saga/effects";
import {
  getLoginDetail,
  getLoginDetailFailure,
  getLoginDetailSuccess,
} from "./loginSlice";
import { apiQueryWithToken } from "../../../services/apiBaseUrlConfig";
import { ENDPOINT } from "../../../services/endpoint.config";

function* getLoginDetails(action) {
  try {
    const response = yield call(() =>
      apiQueryWithToken.post(ENDPOINT.SIGN_IN, action.payload)
    );
    const responseData = response.data;
    yield put(getLoginDetailSuccess(responseData));
  } catch (error) {
    let errorPayload;
    if (typeof error === 'string') {
      errorPayload = error;
    } else if (error && typeof error.message !== 'undefined') {
      errorPayload = error.message;
    } else {
      errorPayload = error;
    }
    yield put(getLoginDetailFailure(errorPayload));
  }
}

function* watchLoginDetail() {
  yield takeLatest(getLoginDetail.type, getLoginDetails);
}

export { getLoginDetails };
export default watchLoginDetail;
